/**
 * Aufgaben einer Bestellung - die Unterressource `/api/orders/:id/tasks`
 * (`backend/src/http/routes/orderTasks.ts`).
 *
 * ================= WAS HIER BIS ZUM 2026-08-15 STAND, UND WARUM ES NICHT MEHR STIMMT =============
 *
 * Dieses Modul fuehrte genau eine Funktion (`aufgabeAendern`) und darueber die Begruendung, warum es
 * KEINEN Aufrufer gebe: "Eine Verdrahtung braucht zuerst einen LESEWEG je Unterressource ... eine
 * Notloesung mit erfundener Versionsnummer waere genau der stille Fehlschlag, den Task 5a beseitigt."
 * Das war richtig gemessen und ist seit dem 2026-08-13 UEBERHOLT: `ladeBestellung`/`ladeBestellungen`
 * liefern `tasks` flach am Bestellobjekt mit (`backend/src/domaene/orders.ts`, Abschnitt "WARUM
 * `tasks` UND `payments` AN DER OBERSTEN EBENE STEHEN"), und weil sie durch `oeffentlich()` laufen,
 * traegt JEDE geladene Aufgabe ihre eigene `rowVersion`. Der Leseweg, auf den die alte Begruendung
 * wartete, ist da - er heisst nur nicht `GET /api/orders/:id/tasks`.
 *
 * Solange das niemand nachgezogen hat, schrieb `TasksTab.tsx` weiter in der Form des BESTANDS: das
 * ganze `tasks`-Array als EIN Feld der Bestellung, ueber `bestellungAendern`. Im Bestand war das der
 * richtige Weg (die Bestellung war ein JSON-Blob, `cloudflare/src/worker.ts:663`, und
 * `permissionForOrderField` ordnete `tasks` schlicht `manage_tasks` zu). Hier laeuft es in RIEGEL 2
 * (`FeldOhneGruppeFehler`, `api/bestellungen.ts`) - jeder Klick auf "Task hinzufuegen" endete im
 * Toast "Die Bestellung konnte nicht geaendert werden."
 *
 * ================= DER KOERPER TRAEGT snake_case - NICHT camelCase ===============================
 *
 * BERICHTIGUNG einer Angabe, die hier bis zum 2026-08-15 stand: "`felder` ist ein nicht-leeres Objekt
 * der zu aendernden Task-Spalten (camelCase, wie `oeffentlich()` sie liefert)". Das ist falsch und
 * waere teuer geworden - `schreibeTask` (`backend/src/domaene/tasks.ts`) prueft jeden Schluessel
 * gegen `TASK_FELDER` (`backend/src/domaene/schreibbareFelder.ts`), und die Liste steht in
 * snake_case: `phase_id`, `responsibility_id`, `deputy_assignee`, `done_at`, `sort_index`,
 * `template_row_id`. Ein camelCase-Schluessel trifft dort NICHTS und wird mit
 * `FeldNichtInGruppeError` abgewiesen.
 *
 * Aufgefallen ist die Angabe nur nicht, weil die Backend-Tests ausschliesslich `done`, `title` und
 * `kind` schreiben (`backend/test/integration/domaene-tasks.test.ts`) - drei EINWORTFELDER, bei denen
 * beide Schreibweisen zusammenfallen. Die Naht ist damit dieselbe wie bei den Feldgruppen der
 * Bestellung: KOERPER snake_case, ANTWORT camelCase (siehe Kopfkommentar `api/bestellungen.ts`).
 *
 * Deshalb steht die Umsetzung unten als TABELLE (`AUFGABEN_SPALTEN`) und nicht als mechanische
 * Umformung: sie ist zugleich die ERLAUBNISLISTE. Was nicht darin steht, geht nicht hinaus.
 *
 * ================= `title` GEGEN `name` - die eine Umbenennung dieser Naht ======================
 *
 * Die Datenbank fuehrt `order_tasks.title`, die Oberflaeche liest `aufgabe.name` - an vier Stellen
 * (`PhasenListe.tsx`, `AufgabenDetail.tsx`, `Historie.tsx`, `lib/payments.ts`). Das Backend hat die
 * Abweichung ausdruecklich BENANNT und NICHT weggerechnet (`backend/src/domaene/orders.ts`,
 * Abschnitt "GEMESSENE ABWEICHUNG"); sie hier aufzuloesen ist damit Sache des Frontends.
 *
 * Sie wird an EINER Stelle aufgeloest, nicht an vieren: `alsAufgabe()` beim Hereinkommen (gerufen von
 * `api/bestellungen.ts#entschachtele`, weil die Aufgaben AM Bestellobjekt hereinkommen),
 * `AUFGABEN_SPALTEN` beim Hinausgehen. Die vier Lesestellen bleiben unangetastet - und `lib/payments.
 * ts#ensurePaymentRequestTask`, das Aufgaben in der Bestandsform ERZEUGT, bleibt damit ebenfalls
 * gueltig.
 *
 * ================= WAS DIE OBERFLAECHE NICHT SCHREIBT, UND WARUM ================================
 *
 * `assignee`/`deputyAssignee` stehen ABSICHTLICH nicht in `AUFGABEN_SPALTEN`, obwohl es die Spalten
 * gibt. Sie sind im neuen Modell Fremdschluessel auf `users` (`005_domaene.sql:170f.`), und sie
 * werden nicht vom Client gesetzt, sondern vom Server abgeleitet: `PATCH /api/responsibility-modules/
 * :moduleId` uebertraegt Hauptverantwortung UND Vertretung in derselben Transaktion auf alle OFFENEN
 * Tasks des Moduls (`backend/src/domaene/zustaendigkeit.ts#uebertrageVerantwortung`; siehe
 * `api/zustaendigkeitsModule.ts`, Abschnitt "Wirkung"). Der Bestand erledigte diese Uebertragung noch
 * selbst (index.html:5667-5683) - hier tut es der Server.
 *
 * Die Oberflaeche schreibt deshalb `responsibilityId` und sonst nichts an der Zuweisung. Ein
 * mitgeschickter Name ("Erika Musterfrau") traefe eine uuid-Spalte und ergaebe SQLSTATE 22P02, also
 * einen 500 - genau deshalb steht `assignee` unten in `KEIN_AUFGABEN_WEG` und wird laut abgewiesen,
 * statt still zu verschwinden oder hart zu scheitern.
 */
import { anfrage } from "./basis.ts";
import { alsAufgabe } from "../lib/bestellungDraht.ts";
import type { OrderTask } from "../lib/types.ts";

/**
 * Feldname der Oberflaeche -> Spalte von `order_tasks` (snake_case). ZUGLEICH die Erlaubnisliste:
 * was hier nicht steht, geht nicht hinaus (siehe `KEIN_AUFGABEN_WEG` und `spaltenFuer` unten).
 *
 * `Map` und kein Objektliteral - dieselbe Begruendung wie bei `GRUPPE_JE_FELD` in
 * `api/bestellungen.ts`: der Schluessel kommt aus einem Aenderungsobjekt, also aus Daten, und ein
 * Objekt-Lookup damit greift bei `"constructor"`/`"__proto__"` auf `Object.prototype` durch.
 *
 * Jeder Eintrag steht in `backend/src/domaene/schreibbareFelder.ts#TASK_FELDER` - `test/komponenten/
 * api/aufgaben.test.ts` haelt beide Listen gegeneinander, damit sie nicht auseinanderlaufen.
 */
export const AUFGABEN_SPALTEN: ReadonlyMap<string, string> = new Map([
  ["name", "title"],
  ["description", "description"],
  ["phaseId", "phase_id"],
  ["due", "due"],
  ["done", "done"],
  ["responsibilityId", "responsibility_id"],
]);

/**
 * Felder, die die Oberflaeche an einer Aufgabe fuehrt, die aber NICHT von ihr geschrieben werden -
 * mit dem gemessenen Grund. Dieselbe Bauform wie `KEIN_FELDGRUPPEN_WEG` in `api/bestellungen.ts`,
 * und aus demselben Grund: ohne diese Tabelle stuende in der Meldung nur "kennt das Feld nicht", und
 * der naechste Leser begaenne die Suche von vorn, die diesen Vorgang schon einmal gekostet hat.
 *
 * KEINE Erlaubnisliste - jedes Feld hier wirft genauso wie ein Tippfehler.
 */
export const KEIN_AUFGABEN_WEG: ReadonlyMap<string, string> = new Map([
  [
    "assignee",
    "Fremdschluessel auf users (005_domaene.sql:170), kein freier Name wie im Bestand. Wird vom " +
      "Server aus dem Zustaendigkeitsmodul abgeleitet (uebertrageVerantwortung) - der Client " +
      "schreibt responsibilityId und sonst nichts an der Zuweisung",
  ],
  [
    "deputyAssignee",
    "Fremdschluessel auf users (005_domaene.sql:171) - dieselbe Ableitung wie bei assignee",
  ],
  [
    "responsibilityName",
    "Denormalisierung des Bestands (applyResponsibilityToTask, lib/payments.ts): order_tasks fuehrt " +
      "nur responsibility_id, der Name steht in responsibility_modules.name",
  ],
  [
    "kind",
    "nach dem Anlegen unveraenderlich und ausdruecklich NICHT in TASK_FELDER: die Art entscheidet " +
      "ueber die Berechtigung (berechtigungFuerTask, backend/src/domaene/tasks.ts) - ein " +
      "aenderbares kind koennte einen manage_tasks-Nutzer nachtraeglich Zahlungstasks erzeugen lassen",
  ],
  [
    "updatedAt",
    "setzt der Server bei jedem Schreibvorgang selbst (updateVersioned) - ein mitgeschickter Wert " +
      "waere eine Behauptung ueber einen Zeitpunkt, den der Client nicht kennt",
  ],
  [
    "updatedBy",
    "setzt der Server aus dem angemeldeten Nutzer (updateVersioned, akteurId) - im Bestand trug der " +
      "Client den Anzeigenamen ein, im neuen Modell ist es ein Fremdschluessel auf users",
  ],
  [
    "createdAt",
    "order_tasks fuehrt keinen Anlagezeitpunkt (nur updated_at) - siehe TASKFELDER_OHNE_ZIEL in " +
      "backend/src/migration/aufgaben.ts",
  ],
  [
    "doneAt",
    "leitet der Server aus `done` ab (schreibeTask setzt done_at mit, wenn done mitgeschickt wird) - " +
      "zwei Quellen fuer denselben Sachverhalt waeren eine zu viel",
  ],
  [
    "sortIndex",
    "die Reihenfolge der Aufgabenliste. Schreibbar am Backend (TASK_FELDER), aber die Oberflaeche " +
      "bietet kein Umsortieren an - der Wert kommt aus dem Migrationslauf bzw. dem Anlegen",
  ],
  [
    "templateRowId",
    "haelt fest, aus welcher Vorlagenzeile eine Aufgabe entstanden ist (005_domaene.sql:169). Wird " +
      "beim ANLEGEN gesetzt und danach nicht mehr geaendert",
  ],
  ["id", "der Schluessel der Zeile - steht im Pfad, nicht im Koerper"],
  ["rowVersion", "die Version steht im Koerper NEBEN `felder`, nicht darin"],
]);

/**
 * Spalten, in denen der LEERE String kein Wert ist, sondern ein Typfehler.
 *
 * DER FEHLERFALL: `<input type="date">` liefert beim Leeren `""`, und `<select>` liefert fuer
 * "Kein Modul" ebenfalls `""`. Beide Spalten sind aber `date` bzw. `uuid` - Postgres antwortet auf
 * `''::date` mit SQLSTATE 22P02, und das schlaegt als 500 durch, nicht als Fachmeldung. Im Bestand
 * war beides folgenlos, weil die Aufgabe ein freies JSON-Objekt war und `due: ''` dort schlicht
 * "keine Frist" hiess.
 *
 * Beide Spalten sind NULL-faehig (005_domaene.sql:164,168), `null` ist also die richtige
 * Uebersetzung von "nichts eingetragen" - und nicht etwa das Weglassen des Feldes: ein weggelassenes
 * Feld liesse den ALTEN Wert stehen, statt ihn zu raeumen.
 *
 * Die Regel steht HIER und nicht bei den Aufrufern, weil sie an der SPALTE haengt, nicht an der
 * Bedienoberflaeche - jeder kuenftige Aufrufer bekommt sie mit.
 */
const LEER_IST_NULL: ReadonlySet<string> = new Set(["due", "responsibility_id"]);

/**
 * RIEGEL, wortgleich in der Absicht zu RIEGEL 2 in `api/bestellungen.ts`: ein Feld, das keine Spalte
 * hat, darf weder still verschluckt noch blind hinausgeschickt werden. Der Aufruf wirft, BEVOR
 * irgendetwas gesendet wird.
 */
export class FeldOhneSpalteFehler extends Error {
  readonly felder: readonly string[];

  constructor(felder: readonly string[]) {
    const beschreibung = felder
      .map((feld) => {
        const grund = KEIN_AUFGABEN_WEG.get(feld);
        return grund ? `"${feld}" (${grund})` : `"${feld}"`;
      })
      .join(", ");
    super(
      (felder.length === 0
        ? "aufgabeAendern: leeres Aenderungsobjekt - das Backend verlangt ein nicht-leeres `felder`. "
        : `aufgabeAendern: keine Spalte fuer ${beschreibung}. `) +
        "Geschrieben wird ueber PATCH /api/orders/:id/tasks/:taskId; die schreibbaren Spalten stehen " +
        "in backend/src/domaene/schreibbareFelder.ts#TASK_FELDER.",
    );
    this.name = "FeldOhneSpalteFehler";
    this.felder = Object.freeze([...felder]);
  }
}

/**
 * Aenderungsobjekt der Oberflaeche -> Koerperfelder in snake_case. Getrennt von `aufgabeAendern`,
 * damit der Riegel ohne Netzzugriff pruefbar ist - dieselbe Aufteilung wie `gruppeUndFelder` in
 * `api/bestellungen.ts`, und aus demselben Grund: ERST alle Schluessel pruefen, DANN senden. Ein
 * Aufruf mit einem bekannten und einem unbekannten Feld darf gar nichts senden.
 */
export function spaltenFuer(aenderung: Record<string, unknown>): Record<string, unknown> {
  const schluessel = Object.keys(aenderung);
  if (schluessel.length === 0) {
    throw new FeldOhneSpalteFehler([]);
  }
  const unbekannt = schluessel.filter((feld) => !AUFGABEN_SPALTEN.has(feld));
  if (unbekannt.length > 0) {
    throw new FeldOhneSpalteFehler(unbekannt);
  }
  const felder: Record<string, unknown> = {};
  for (const feld of schluessel) {
    const spalte = AUFGABEN_SPALTEN.get(feld)!;
    const wert = aenderung[feld];
    felder[spalte] = wert === "" && LEER_IST_NULL.has(spalte) ? null : wert;
  }
  return felder;
}

// `alsAufgabe` (Serverform -> Form der Oberflaeche, `title` -> `name`) wohnt seit dem KI-Zugang
// (Stufe 1) in `lib/bestellungDraht.ts`, neben `entschachtele`, das sie ruft: der Server faehrt
// dieselbe Umformung. Der Name bleibt hier erreichbar; die Begruendung steht im Kopfkommentar oben.
export { alsAufgabe };

/**
 * `POST /api/orders/:id/tasks`. Der Koerper ist hier - anders als beim PATCH - in camelCase und mit
 * BENANNTEN Feldern (`taskAnlegenAusKoerper`, `backend/src/http/routes/orderTasks.ts`), nicht das
 * generische `felder`-Objekt. Deshalb keine Umsetzung ueber `AUFGABEN_SPALTEN`, sondern die
 * ausdrueckliche Form.
 *
 * `title` ist Pflicht und muss nicht-leer sein - der Bestand legt eine Aufgabe MIT LEEREM NAMEN an
 * (`addTask`, index.html:9161: `name: ''`) und laesst den Nutzer ihn danach im Detailfenster
 * eintippen. Das geht hier nicht: `order_tasks.title` ist NOT NULL, und die Route weist einen leeren
 * Titel mit 400 ab. `TasksTab.tsx` legt deshalb mit einem Vorgabetitel an - siehe dort.
 */
export function aufgabeAnlegen(
  bestellungId: string,
  aufgabe: {
    title: string;
    description?: string | null;
    phaseId?: string | null;
    due?: string | null;
    responsibilityId?: string | null;
    /**
     * `task` (Regelfall, Vorgabe am Backend, wenn weggelassen) oder `payment_request`
     * (`taskAnlegenAusKoerper`, `backend/src/http/routes/orderTasks.ts:163ff`) - verlangt dafuer
     * `request_payment` statt `manage_tasks` (`berechtigungFuerTask`,
     * `backend/src/domaene/tasks.ts`). RICHTIGGESTELLT: der dritte, am Backend bekannte Wert
     * `dsv_klaerung` steht NICHT in `TASK_ARTEN` (`backend/src/domaene/tasks.ts:31` fuehrt nur
     * `task`/`payment_request`) - er ist ausschliesslich im DB-CHECK von `order_tasks.kind` bekannt
     * (`027_order_tasks_dsv_klaerung.sql`) und entsteht automatisch (`dsv/klaerung.ts`), nie ueber
     * diesen POST-Weg. ABSICHTLICH deshalb nicht in dieser Signatur.
     */
    kind?: "task" | "payment_request";
  },
): Promise<OrderTask> {
  return anfrage<Record<string, unknown>>(
    `/api/orders/${encodeURIComponent(bestellungId)}/tasks`,
    { methode: "POST", koerper: aufgabe },
  ).then((roh) => alsAufgabe(roh) as OrderTask);
}

/**
 * `PATCH /api/orders/:id/tasks/:taskId`. `aenderung` steht in der Form der OBERFLAECHE (`name`,
 * `due`, `done`, …) und wird hier auf die Spalten umgesetzt; `rowVersion` ist die der AUFGABE, nicht
 * die der Bestellung - sie steht an jeder geladenen Aufgabe (siehe Kopfkommentar).
 */
export function aufgabeAendern(
  bestellungId: string,
  taskId: string,
  aenderung: Record<string, unknown>,
  rowVersion: number,
): Promise<OrderTask> {
  const felder = spaltenFuer(aenderung);
  return anfrage<Record<string, unknown>>(
    `/api/orders/${encodeURIComponent(bestellungId)}/tasks/${encodeURIComponent(taskId)}`,
    { methode: "PATCH", koerper: { rowVersion, felder } },
  ).then((roh) => alsAufgabe(roh) as OrderTask);
}

/**
 * `DELETE /api/orders/:id/tasks/:taskId`. Antwortet mit `{ ok: true }` und nicht mit der geloeschten
 * Zeile (Antwortform-Konvention, `backend/src/app.ts`) - der Rueckgabewert ist deshalb `void`.
 *
 * Die Route verlangt `manage_tasks`; einen `request_payment`-Sonderweg zum Loeschen gibt es NICHT
 * (`endpunktMatrix.ts`), auch nicht fuer Zahlungstasks.
 */
export function aufgabeLoeschen(
  bestellungId: string,
  taskId: string,
  rowVersion: number,
): Promise<void> {
  return anfrage<{ ok: boolean }>(
    `/api/orders/${encodeURIComponent(bestellungId)}/tasks/${encodeURIComponent(taskId)}`,
    { methode: "DELETE", koerper: { rowVersion } },
  ).then(() => undefined);
}

/**
 * `PATCH /api/orders/:id/tasks/bulk-done` (Auftrag "Meilensteine (Phasen) im Tasks-Tab abhakbar
 * machen") - setzt `done` fuer MEHRERE Tasks EINER Bestellung auf einmal, der Schreibweg hinter der
 * Phasen-Checkbox (`TaskPhaseBlock`, `PhasenListe.tsx`).
 *
 * KEIN `rowVersion`-Parameter, anders als `aufgabeAendern`: die Route prueft die Version je Zeile
 * NICHT (siehe `backend/src/domaene/tasks.ts#schreibeTasksBulk`) - ein Komfort-Bulk-Klick, kein
 * Merge fremder Einzelaenderungen. `taskIds`, die nicht (mehr) zur Bestellung gehoeren, werden vom
 * Server ohne Fehler uebersprungen; die Antwort traegt deshalb nur die TATSAECHLICH geaenderten
 * Zeilen, moeglicherweise weniger als `taskIds` lang ist.
 */
export function aufgabenBulkErledigen(
  bestellungId: string,
  taskIds: readonly string[],
  done: boolean,
): Promise<OrderTask[]> {
  return anfrage<Record<string, unknown>[]>(
    `/api/orders/${encodeURIComponent(bestellungId)}/tasks/bulk-done`,
    { methode: "PATCH", koerper: { taskIds, done } },
  ).then((roh) => roh.map((zeile) => alsAufgabe(zeile) as OrderTask));
}

/** Ergebnis von `POST /api/orders/:id/tasks/vorlage-anwenden` - siehe `vorlageAufBestellungAnwenden`. */
export interface VorlageAnwendenErgebnis {
  /** Anzahl der TATSAECHLICH neu angelegten Tasks - 0 ist ein gueltiges Ergebnis, kein Fehlschlag. */
  hinzugefuegt: number;
}

/**
 * `POST /api/orders/:id/tasks/vorlage-anwenden` (`backend/src/http/routes/orderTasks.ts`) - wendet
 * die aktive Aufgabenvorlage (`task_templates`) manuell auf eine BEREITS bestehende Bestellung an.
 * Derselbe Schritt, den `legeBestellungAn()` (backend/src/domaene/orders.ts) seit diesem Auftrag
 * automatisch bei jeder Bestellanlage macht - hier gezielt nachgeholt, z. B. nachdem die Vorlage um
 * Zeilen ergaenzt wurde (`VorlagenDialog.tsx`).
 *
 * Idempotent (`wendeVorlageAufBestellungAn`, domaene/tasks.ts): eine Vorlagenzeile, die schon einen
 * Task hat, erzeugt keinen zweiten - `hinzugefuegt: 0` ist deshalb ein gueltiges Ergebnis, kein
 * Fehlerfall ("die Vorlage war bereits vollstaendig angewendet").
 *
 * Kein Koerper noetig - die Route liest ausschliesslich die Bestellkennung aus dem Pfad.
 *
 * Die Antwort traegt zusaetzlich `tasks` (die neu angelegten Zeilen) - HIER BEWUSST NICHT
 * ausgewertet (Review-Befund, Geringer Punkt: `VorlageAnwendenErgebnis.tasks` samt `alsAufgabe()`-
 * Umformung war toter Code ohne Abnehmer). `App.tsx#drawerVorlageAnwenden` laedt nach einem
 * erfolgreichen Aufruf ohnehin die GANZE Bestellung neu (`aufgabenNachladen`) - derselbe Weg, den
 * auch `aufgabeAnlegen`/`-Aendern`/`-Loeschen` gehen (siehe deren Kopfkommentar, "ALLE VIER LADEN
 * DIE BESTELLUNG NACH"). Eine zweite, hier verarbeitete Kopie derselben Zeilen haette also nirgends
 * einen Leser.
 */
export function vorlageAufBestellungAnwenden(bestellungId: string): Promise<VorlageAnwendenErgebnis> {
  return anfrage<VorlageAnwendenErgebnis>(
    `/api/orders/${encodeURIComponent(bestellungId)}/tasks/vorlage-anwenden`,
    { methode: "POST" },
  );
}
